<template>
  <div class="expert-item-container">
    <custom-router-link :item="info" class="detail-link" :to="{name: detailName, params: {id: info.id}}" target="_blank">
      <div class="expert-avator">
        <el-image :src="projectFileUrl+info.image" fit="cover"></el-image>
      </div>
      <div class="expert-info">
        <div class="expert-name">{{info.name}}</div>
        <div class="expert-summary">{{info.summary}}</div>
      </div>
      <div class="more-info">
        <span>了解更多&nbsp;<i class="el-icon-right"></i></span>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailName: ""
    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {
    this.detailName = this.$route.name + "Details";
  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.expert-item-container {
  width: calc((100% - 90px) / 4);
  height: 440px;
  background: #fff;
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
  .detail-link {
    display: block;
    width: 100%;
    height: 100%;
    .expert-avator {
      width: 100%;
      height: 260px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .expert-info {
      padding: 14px 20px;
      .expert-name {
        text-align: center;
        line-height: 32px;
        margin-bottom: 10px;
        color: #212529;
        font-size: 20px;
        font-weight: 600;
      }
      .expert-summary {
        line-height: 20px;
        height: 60px;
        color: #6c757d;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .more-info {
      padding: 0 20px;
      display: flex;
      font-size: 16px;
      color: #212529;
      line-height: 32px;
      span {
        border-bottom: 2px solid #2960a7;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .expert-item-container {
    width: 100%;
    height: 400px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    .detail-link {
      .expert-avator {
        width: 50%;
        height: 240px;
        margin: 0 auto;
        padding: 14px 0 0;
      }
      .expert-info {
        padding: 14px 20px;
        .expert-name {
          text-align: center;
          line-height: 28px;
          margin-bottom: 6px;
          font-size: 18px;
        }
        .expert-summary {
          line-height: 20px;
          height: 60px;
          color: #6c757d;
          font-size: 14px;
        }
      }
      .more-info {
        padding: 0 14px;
        display: flex;
        font-size: 12px;
        color: #212529;
        line-height: 24px;
        span {
          border-bottom: 1px solid #2960a7;
          font-weight: 600;
        }
      }
    }
  }
}
</style>